import axiosClient from "utils/api/axios-client";

export default {
  getAll: (params) => {
    const url = "/api/v1/express/combos";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/express/combos/${id}`;
    return axiosClient.get(url);
  },
  create: (combo) => {
    const url = `/api/v1/express/combos/`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.post(url, combo, config);
  },
  update: (id, combo) => {
    const url = `/api/v1/express/combos/${id}`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.put(url, combo, config);
  },
  delete: (id) => {
    const url = `/api/v1/express/combos/${id}`;
    return axiosClient.delete(url);
  },
};
